<template>
  <div>
    <!-- v-validate="'required|email|min:3'" -->

    <!-- <vs-input
        v-validate="'required|min:5'"
        data-vv-validate-on="blur"
        name="userId"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="ID"
        v-model="userId"
        class="w-full"/> -->
        <vs-input
        v-validate="'required|email'"
        data-vv-validate-on="blur"
        name="email"
        type="email"
        icon-pack="feather"
        icon-no-border
        icon="icon icon-mail"
        label-placeholder="이메일"
        v-model="email"
        @keyup.enter="loginJWT"
        class="w-full"
        />
        <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <!-- <span class="text-danger text-sm">{{ errors.first('email') }}</span> -->
    <span class="text-danger text-sm"></span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:15'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="비밀번호"
        v-model="password"
        @keyup.enter="loginJWT"
        class="w-full mt-6" />
    <!-- <span class="text-danger text-sm">{{ errors.first('password') }}</span> -->

    <div class="flex flex-wrap justify-between my-5">
        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/pages/forgot-password">Forgot Password?</router-link> -->
        <vs-checkbox v-model="checkbox_remember_me"  class="mb-3">기억하기</vs-checkbox>
        <router-link to="/pages/forgot-password">비밀번호를 잊어버리셨나요?</router-link>
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <!-- <vs-button  type="border" @click="registerUser">Register</vs-button>
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button> -->
      <vs-button class="w-full" :disabled="!validateForm" @click="loginJWT"  style="margin-bottom:10px;">로그인</vs-button>
      <vs-button class="w-full" type="border" @click="registerUser">가입하기</vs-button>
    </div>
  </div>
</template>


<script>

// const dict ={
//  custom:{
//    email: {
//        required: 'Email is required',
//        email: "Please enter valid email"
//    },
//  }
// };
//
// Validator.localize('kr', dict);

export default {
  created () {
    localStorage.removeItem('filleduToken')
    localStorage.removeItem('userInfo')
    sessionStorage.removeItem('filleduToken')
    sessionStorage.removeItem('userInfo')
  },
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,

    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '';
    },
    // adminUserList(){
    //   return this.$store.state.adminUserList
    // },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          // text: 'You are already logged in!',
          text: '이미 로그인 되어 있습니다.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },

    loginJWT() {
      if (!this.checkLogin()) return
      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then((resolve) => {
          this.$vs.loading.close()
          if(this.activeUserInfo.level == 11){
            this.$acl.change('admin')
            this.$router.push('/apps/epractice')
            return
          }
          if(this.superAdmin == resolve.data.userData.email){
            this.$acl.change('superAdmin')
            this.$router.push('/apps/admin/etest')
            return
          }
          // const mailIndex = this.adminUserList.findIndex((mail) => mail == resolve.data.userData.email)
          if(resolve.data.userData.userRole == 'admin'){
            this.$acl.change('admin')
            this.$router.push('/apps/etest')
            return
          }
          this.$acl.change('editor')
          if(resolve.data.first == true){
            this.$router.push('/pages/login/password')
          } else {
            this.$router.push('/apps/space')
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    }
  }
}

</script>
